export function isOwnApiRequest(url: string, apiUrl: string): boolean {
  if (apiUrl) return url.startsWith(apiUrl);
  return url.startsWith('/api/');
}
